<template>
    <document-rule-table></document-rule-table>
</template>

<script>
    const documentRuleTable =() => import ('@/components/orgApps/DocumentRule/DocumentRuleTable');

    export default {
        name: "documentRuleDash",
        components: {
            documentRuleTable
        }
    }
</script>

<style scoped>

</style>